module.exports = __webpack_public_path__ + "img/laboratorio_4-3_3072.f255779c.jpg";